import {omniFetch} from "~/utils/fetch";
import {config} from "~/utils/config";

export function capsuleCreate({capsuleName}) {
  return omniFetch({
    url: config.v1Path + config.capsuleCreatePath,
    method: "post",
    params: {capsuleName}
  })
}

export function capsuleList({pageIndex, pageSize, shopProductId}) {
  return omniFetch({
    url: config.v1Path + config.capsuleListPath,
    method: "post",
    params: {pageIndex, pageSize, shopProductId}
  })
}

export function capsuleAddProduct({capsuleId, shopProductId}) {
  return omniFetch({
    url: config.v1Path + config.capsuleAddProductPath,
    method: "post",
    params: {capsuleId, shopProductId}
  })
}

export function capsuleRemoveProduct({capsuleId, shopProductId}) {
  return omniFetch({
    url: config.v1Path + config.capsuleRemoveProductPath,
    method: "post",
    params: {capsuleId, shopProductId}
  })
}

export function capsuleUpdateName({capsuleId, capsuleName}) {
  return omniFetch({
    url: config.v1Path + config.capsuleUpdateNamePath,
    method: "post",
    params: {capsuleId, capsuleName}
  })
}

export function capsuleDelete({capsuleId}) {
  return omniFetch({
    url: config.v1Path + config.capsuleDeletePath,
    method: "post",
    params: {capsuleId}
  })
}
